import { ValidateField } from 'helpers/Validation';

export const HMISectionCulatedRangeFormula = (lrv, urv, engineeringUnit) => `${ValidateField(lrv)} - ${ValidateField(urv)} ${ValidateField(engineeringUnit)}`;
